export const GET_PRODUCTS_QUERY = `
  query getProducts($first: Int, $query: String) {
    products(first: $first, query: $query) {
      edges {
        node {
          id  
          title
          tags
          handle
          vendor
          productType
          totalInventory
          collections(first: 250) {
            nodes {
              handle
            }
          }
          featuredImage {
            url
          }
          priceRange {
            maxVariantPrice {
              amount
            }
            minVariantPrice {
              amount
            }
          }
        }
      }
    }
  }
`;

